import VueRouter from 'vue-router'
import Vue from 'vue'

const RouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return RouterPush.call(this, to).catch(err => err)
}
const RouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (to) {
  return RouterReplace.call(this, to).catch(err => err)
}

Vue.use(VueRouter);

const routes = [  
  {
    // 配置默认路由
    name:"index",
    path: '/',
    component:() => import('../views/LayoutLogin.vue')
  }, 
  {
    name:"main",
    path: '/main',      
    component: () => import('../views/LayoutMain.vue'),
    //redirect: '/hello',
    children: [
      {
        name:"hello",
        path: '/hello',
        component: () => import('../views/HelloWorld.vue')
      },{
        name:"popDownTypeList",//字典类型列表
        path: '/popDownTypeList',
        component: () => import('../views/hr/systemSet/popDownType.vue')
      } ,{
        name:"popDownList",//字典类型列表
        path: '/popDownList',
        component: () => import('../views/hr/systemSet/popDown.vue')
      } ,{
        name:"accountList",//用户列表
        path: '/accountList',
        component: () => import('../views/hr/account/accountList.vue')
      } ,{
        name:"moduleList",//模块列表
        path: '/moduleList',
        component: () => import('../views/hr/module/moduleList.vue')
      }, {
        name:"roleList",//权限列表
        path: '/roleList',
        component: () => import('../views/hr/module/roleList.vue')
      },  {
        name:"authorityList",//授权列表
        path: '/authorityList',
        component: () => import('../views/hr/module/authorityList.vue')
      },{
        name:"studentList",//学生列表
        path: '/studentList',
        component: () => import('../views/student/studentList.vue')
      },{
        name:"queList",//题库列表
        path: '/queList',
        component: () => import('../views/questions/queList.vue')
      },{
        name:"queResultList",//答题结果
        path: '/queResultList',
        component: () => import('../views/questions/queResultList.vue')
      }
      ,{
        name:"queTypeList",//答题分类
        path: '/queTypeList',
        component: () => import('../views/questions/queTypeList.vue')
      }
    ]
  }, {
    name:"login",
    path: '/login',
    component: () => import('../views/LayoutLogin.vue')
  }
  , {
    name:"error",
    path: '/error',
    component: () => import('../components/ErrorIndex.vue')
  },  
]

const router = new VueRouter({
    base: '/tzweb/',
    mode: 'hash',//hash  history
    routes 
  })

export default router

